@if (product) {
<div class="flex flex-top"
     [class]="isMinibasket ? 'p-t-6 p-b-6 p-t-4-s p-b-4-s p-t-4-m p-b-4-m' : ''">
    <!-- image -->
    <div class="pos-relative m-r"
         [style.minWidth.px]="client.sizeId < 1 ? 100 : 126"
         [style.minHeight.px]="client.sizeId < 1 ? 100 : 126">
        <a class="b-a b-col-5 overflow-hidden inline-flex"
           style="border-radius: 12px;"
           [routerLink]="product.data?.url">
            <img [ratio]="1"
                 [width]="client.sizeId < 1 ? 100 : 126"
                 [dfImage]="product.data?.image">
        </a>

        <product-wishlist-toggle [productId]="product.id"
                                 class="pos-absolute z-4 top-1 right-1 basket-wishlist-icon">
        </product-wishlist-toggle>
    </div>
    <!-- details -->
    <div class="_right-column flex-column flex-justify-between p-l">
        <div>
            <div class="p-l-3 p-b p-l-1-s p-l-1-m float-right flex flex-reverse">
                <price class="p1 col-1 block price"
                       [value]="rowPrice"></price>
                @if (rowOrgPrice && client.sizeId > 1) {
                <price class="p1 col-11 line-through m-r-1 block"
                       [value]="rowOrgPrice"></price>
                }
            </div>
            <a class="p1 col-1 block"
               [routerLink]="item?.url">{{ product.parent?.data?.name || product.data?.name || '' }}</a>
            <!-- qty -->
        </div>

        <div class="m-t">
            @if(item?.customOptions?.length || item?.configurableOptions?.length) {
            <div class="m-b-3">
                <!-- configurable options -->
                @if (item?.configurableOptions?.length) {
                <span class="c1 col-11">
                    @for (option of item?.configurableOptions; track option; let index = $index) {
                    <span class="block-s m-b-1">
                        @if (index && !app.client.isS) {
                        <span class="m-l-1 m-r-1 inline-block">·</span>
                        }
                        {{ option.code | attributeLabel }}:
                        {{ option.value | optionLabel : option.code}}
                    </span>
                    }
                </span>
                }
                @if(item?.customOptions?.length) {
                <span class="c1 col-11">
                    @for (option of item?.customOptions; track option) {
                    @if (!app.client.isS) {
                    <span class="m-l-1 m-r-1 inline-block">·</span>
                    }
                    {{ option.title }}: {{ option.labels[0] }}
                    }
                </span>
                }
            </div>
            }
            @if (!nonEditable) {
            @if (item?.qtyEditable) {
            <basket-item-qty [model]="data.qty || null"
                             [max]="(maxQty ?? 0) > 9999 ? 9999 : maxQty"
                             [min]="product?.moq || 1"
                             [step]="product?.qtyIncrements || 1"
                             [status]="status"
                             style="width: 68px; height: 40px"
                             class="inline-block va-m m-r"
                             (qtyChange)="setQty($event)"></basket-item-qty>
            }
            <button inlineButton
                    class="va-m s2"
                    [status]="removeStatus"
                    (click)="remove()"
                    cy-basketRemove>{{'Remove' | translate}}</button>
            }
        </div>
        @if (nonEditable) {
        <p class="c1 col-11">{{ 'Qty: %' | translate : data.qty }}</p>
        }
        <!-- error handling -->
        @if (warning) {
        <p class="p2 col-2 m-t-2">{{warning}}</p>
        }
        <result [status]="status"></result>
        <result [status]="removeStatus"></result>
    </div>
</div>
}